import React from 'react'
import { Bookmark } from 'lucide-react'
import { useWatchlist } from '../../contexts/WatchlistContext'
import type { WatchlistEntityType } from '../../services/watchlist'

interface WatchlistIndicatorProps {
  entityType: WatchlistEntityType
  entityId: string
  className?: string
}

/**
 * Inline bookmark shown immediately after an entity name when it is on the watchlist.
 * Renders nothing when the entity is not watched.
 */
const WatchlistIndicator: React.FC<WatchlistIndicatorProps> = ({
  entityType,
  entityId,
  className = '',
}) => {
  const { isWatched } = useWatchlist()
  if (!isWatched(entityType, entityId)) return null

  return (
    <span
      role="img"
      aria-label="På watchlist"
      title="På watchlist"
      data-testid="watchlist-indicator"
      className={`inline-flex shrink-0 align-[-0.125em] ${className}`}
    >
      <Bookmark className="h-3 w-3 text-signal fill-current" aria-hidden />
    </span>
  )
}

export default WatchlistIndicator
